<template>
    <!-- BEGIN SIDEBAR -->
    <div class="page-sidebar-wrapper">
        <!-- BEGIN SIDEBAR -->

        <div class="page-sidebar navbar-collapse" :class="{collapse: collapsed}">
            <!-- BEGIN SIDEBAR MENU -->
            <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
            <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
            <ul class="page-sidebar-menu page-header-fixed " :class="{'page-sidebar-menu-closed': collapsed}"
                style="padding-top: 20px">

                <v-sidebar-search></v-sidebar-search>

                <v-sidebar-item-group
                        routeGroup="Logs" title="Logs"
                        icon="icon-note">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu"
                                v-show="props.expanded">
                                <v-sidebar-link title="Transaction log"
                                                routeName="log.transactions"
                                                icon="icon-list">
                                </v-sidebar-link>
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <v-sidebar-item-group
                        routeGroup="Metrics" title="Metrics"
                        icon="icon-graph">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu"
                                v-show="props.expanded">
                                <v-sidebar-link routeName="metrics.user"
                                                title="Customers"
                                                icon="icon-user"/>
                                <v-sidebar-link routeName="metrics.claims"
                                                title="Claims"
                                                icon="icon-link"/>
                                <v-sidebar-link routeName="metrics.transactions"
                                                title="Transactions"
                                                icon="icon-book-open"/>
                                <v-sidebar-link routeName="metrics.cashback"
                                                title="Cashback"
                                                icon="icon-calculator"/>
                                <v-sidebar-link routeName="metrics.popular"
                                                title="Popular deals"
                                                icon="icon-trophy"/>
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <v-sidebar-item-group
                        routeGroup="Alerts" title="Alerts"
                        icon="icon-support">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu"
                                v-show="props.expanded">
                                <v-sidebar-link routeName="alerts.deals"
                                                title="Deal Alerts"
                                                icon="icon-bubble"/>
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <v-sidebar-item-group
                        routeGroup="Customers" title="Customers"
                        icon="icon-user">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu"
                                v-show="props.expanded">
                                <v-sidebar-link title="Customer details"
                                                routeName="user.index"
                                                icon="icon-people">
                                </v-sidebar-link>
                                <v-sidebar-link title="Link customer to deal"
                                                routeName="user.link"
                                                icon="icon-link">
                                </v-sidebar-link>
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <li class="nav-item"><a :href="tuangoDashboardUrl" target="_blank"
                                        class="nav-link">
                    <i class="icon-organization"></i>
                    <span class="title">Local Deals</span> </a></li>

            </ul>
            <!-- END SIDEBAR MENU -->

        </div>
        <!-- END SIDEBAR -->
    </div>
    <!-- END SIDEBAR -->
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import VSidebarSearch from './SidebarSearch'
  import VSidebarItemGroup from './SidebarItemGroup'
  import VSidebarLink from './SidebarLink'
  import VSlideToggleTransition from '@/app/components/transitions/SlideToggleTransition'

  const $ = require('jquery')
  const {mapState} = createNamespacedHelpers('app')

  export default {
    components: {
      VSidebarSearch,
      VSidebarItemGroup,
      VSidebarLink,
      VSlideToggleTransition
    },
    data () {
      return {
        desktopMq: 992,
        collapsed: true
      }
    },
    computed: {
      ...mapState({
        appSections: state => state.appSections,
        currentSection: state => state.section,
        selectedDeal: state => state.selectedDeal
      }),
      tuangoDashboardUrl () {
        if (window.location.href.includes('localhost')) {
          return 'http://localhost:9300'
        } else if (window.location.href.includes('dashboard-dev')) {
          return 'https://dashboard-dev.lod.tuango.ca'
        } else {
          return 'https://dashboard.lod.tuango.ca'
        }
      }
    },
    methods: {
      windowResize () {
        if (this.$mq.below(this.desktopMq)) {
          this.collapsed = true
        } else {
          this.collapsed = false
        }
        this.changeBodyClass(this.collapsed)
      },
      changeBodyClass (isCollapsed) {
        const $body = $('body')

        if (isCollapsed) {
          $body.addClass('page-sidebar-closed')
        } else {
          $body.removeClass('page-sidebar-closed')
        }
      },
      toggleSidebar () {
        // @todo Implement jQuery slide toggle behavior
        // const $sidebar = $('.page-sidebar')
        // $sidebar.slideToggle()
        this.collapsed = !this.collapsed
        this.changeBodyClass(this.collapsed)
      }
    },
    watch: {
      '$mq.resize': 'windowResize'
    },
    mounted () {
      this.windowResize()
    }
  }
</script>

<style lang="scss">
    .page-sidebar .page-sidebar-menu li.active > .sub-menu {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/app/components/sidebar/Sidebar.vue